<template>
  <div class="home" :class="[colorTheme]">
    <v-app id="inspire">
    </v-app>
  </div>
</template>

<script>
// @ is an alias to /src


import router from '@/router';

export default {
  created: function () {
    this.$store.commit('resetState');
    this.$store.commit('setRestaurantSlug', this.$route.params.urlSlug);
    this.$store.commit('setOrderType', 2); // takeaway
    this.$store.dispatch('getRestaurantMenu').then((response) => {
      if (!response || response === 0) return;
      const shop = response.data && response.data.shop ? response.data.shop : this.$store.state.shop;
      if (shop && shop.is_factory_building === 1) {
        this.$store.commit('setFactoryStaffDialogVisible', true);
      } else {
        router.push({ path: '/takeAwayMenu' });
      }
    });
  },

  watch: {
    factoryStaffConfirmed(val) {
      if (val) {
        router.push({ path: '/takeAwayMenu' });
      }
    },
  },

  data: () => ({
    drawer: null,
  }),
  computed: {
    colorTheme: function () {
      return this.$store.state.shop.color_theme;
    },
    factoryStaffConfirmed() {
      return this.$store.state.factoryStaffConfirmed;
    },
  },
}
</script>
